const farmasep = {
  title: 'farmaSEP',
  main: { title: 'Ahorre más que nunca en sus medicamentos' },
  form: {
    drugName: 'Nombre de medicamento',
    drugPlaceholder: 'Ingresar medicamento (ej. Lexapro)',
    zipCode: 'Código postal',
    search: 'Compare precios',
  },
  content: {
    popular: 'Búsquedas frecuentes',
    drugstores: 'Aceptado en estas farmacias',
  },
  popularSeaches: {
    drug: [
      {
        drugName: 'Lexapro',
      },
      {
        drugName: 'Sildenafil',
      },
      {
        drugName: 'Norvasc',
      },
      {
        drugName: 'Lipitor',
      },
      {
        drugName: 'Zoloft',
      },
      {
        drugName: 'Cozaar',
      },
    ],
  },
  retailers: [
    {
      image: 'https://images.contentstack.io/v3/assets/bltd488044897c9abc0/bltd4b2d53fd99f1dd7/5f5fac59f0d2b04fae76a553/target.png',
    },
    {
      image: 'https://images.contentstack.io/v3/assets/bltd488044897c9abc0/blt8d27c610b9ff5b37/5f5fac590c4cec6883883558/walmart.png',
    },
    {
      image: 'https://images.contentstack.io/v3/assets/bltd488044897c9abc0/blt8f5b4a9b04f0d095/5f5fac596f40ab4648b5c2a0/safeway.png',
    },
    {
      image: 'https://images.contentstack.io/v3/assets/bltd488044897c9abc0/bltada585284b76b343/5f5fac5aad6ff34788c03540/walgreens.png',
    },
  ],
  result: {
    brand: "Marca",
    generic: "Genérico",
    type: "Forma",
    concentration: "Concentración",
    quantity: "Cantidad",
    coupon: "Ver cupón",
    results: "RESULTADOS PARA",
    noResults:"Sin resultados",
    resultMessage: "Intente modificar su búsqueda",
    suggestion: "Le sugerimos verificar la ortografía o probar un código postal distinto.",
    dismiss:"Pruebe otra búsqueda"
  },
  social_share: {
    copy_link: "¡Enlace copiado!"
  }
};

export default farmasep;
